import React from 'react'
import {
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
  MotifIconButton,
} from '@ey-xd/motif-react'
import {
  IconoirCircle,
  IconoirPlusCircle,
  IconoirMinusCircle,
} from '@ey-xd/motif-icon'
import classNames from 'classnames'
import './MappingModal.scss'
import { MappingItemType } from './type'

export default function MappingItem({
  text,
  itemId,
  handleMapping,
  isMapped,
  mappedId,
  isSource,
  handleRemoveMapping,
}: MappingItemType) {
  return (
    <div
      className={classNames('mapping-item', {
        disabled: isSource && isMapped,
      })}
      id={itemId}
      onClick={() => handleMapping(itemId)}
    >
      {text}
      {(!isSource && isMapped) ? (
        <MotifDropdown
          closeOnOutsideClick
          id="dropdown-1"
          className="mapped-btn"
          trigger={
            <MotifIconButton className="mapping-btn" type="button">
              <MotifIcon
                size="24"
                className={classNames({
                  mapped: isMapped,
                })}
                src={IconoirMinusCircle}
              />
            </MotifIconButton>
          }
        >
          <ul aria-label="fruits" role="menu">
            <li role="menuitem">
              <MotifDropdownItem
                indexItem={1}
                onClick={() => handleRemoveMapping(itemId)}
              >
                Remove Mapping{' '}
              </MotifDropdownItem>
            </li>
          </ul>
        </MotifDropdown>
      ) : !isSource && (
        <MotifIconButton className="mapping-btn" type="button">
          <MotifIcon
            size="24"
            className={classNames({
              'not-mapped': !isMapped,
            })}
            src={IconoirCircle}
          />
        </MotifIconButton>
      )}
      {isSource && (
        <MotifIconButton className="mapping-btn" type="button">
          <MotifIcon
            size="24"
            className={classNames({
              mapped: isMapped,
              'not-mapped': !isMapped,
            })}
            src={IconoirPlusCircle}
          />
        </MotifIconButton>
      )}
    </div>
  )
}
